import { APP_COLORS, APP_FONT_WEIGHT, APP_SIZES } from 'constants/vars';
import { FC, HTMLAttributes } from 'react';
import { TitleProps } from 'antd/lib/typography/Title';

import { StyledTitle } from './styled';

export interface IProps
  extends Omit<HTMLAttributes<TitleProps>, 'size' | 'color'> {
  color?: keyof typeof APP_COLORS;
  textAlign?: 'center' | 'left' | 'right';
  size?: keyof typeof APP_SIZES;
  fontWeight?: keyof typeof APP_FONT_WEIGHT;
  lineHeight?: number;
  level?: TitleProps['level'];
}

const Title: FC<IProps> = ({
  children,
  color = 'text-100',
  textAlign,
  size = '24',
  fontWeight = '600',
  lineHeight,
  level = 1,
  ...rest
}) => (
  <StyledTitle
    level={level}
    $color={color}
    $lineHeight={lineHeight}
    $fontWeight={fontWeight}
    $textAlign={textAlign}
    $size={size}
    {...rest}
  >
    {children}
  </StyledTitle>
);

export default Title;
